export default __webpack_public_path__ + "static/media/casal_7.80710719.jpg";